// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-info {
  border-radius: 16px;
  box-shadow: 0px 2px 4px 0 #808080;
}

.box-message-info {
  display: flex;
  align-items: center;
  background-color: #e6f9e6;
  border: 1px solid #b3e6b3;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 16px;
  color: #333;
  margin: 16px 0;
}
.box-message-info .info-icon {
  color: #28a745;
  font-size: 24px;
  margin-right: 12px;
}
.box-message-info .info-message {
  color: #333;
}

.images-preview {
  display: flex;
  overflow-x: auto;
  gap: 16px;
  padding: 8px;
  scroll-snap-type: x mandatory;
}

.image-preview-item {
  flex: 0 0 calc(50% - 16px);
  scroll-snap-align: start;
  position: relative;
}

.image-diagnostis {
  width: 100%;
  height: 500px;
  border-radius: 8px;
}

.delete-image {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
}

.image-thumnail {
  max-width: 60px;
  min-width: 60px;
  height: 60px;
}

.nuti-summary {
  display: flex;
  align-items: center;
}

.box-category {
  border: solid 2px rgba(0, 128, 0, 0.2588235294);
}

.box-info-image {
  height: 100px;
  max-height: 100px;
  width: 100%;
}

@media (max-width: 426px) {
  .image-preview-item {
    flex: 0 0 calc(100% - 16px);
    scroll-snap-align: start;
    position: relative;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TrainingData/DiagnosticResult.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AACJ;AAEE;EACE,WAAA;AAAJ;;AAIA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;AADF;;AAIA;EACE,0BAAA;EACA,wBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,+CAAA;AADF;;AAIA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;AADF;;AAIA;EACE;IACE,2BAAA;IACA,wBAAA;IACA,kBAAA;EADF;AACF","sourcesContent":[".box-info {\n  border-radius: 16px;\n  box-shadow: 0px 2px 4px 0 #808080;\n}\n\n.box-message-info {\n  display: flex;\n  align-items: center;\n  background-color: #e6f9e6;\n  border: 1px solid #b3e6b3;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 16px;\n  color: #333;\n  margin: 16px 0;\n\n  .info-icon {\n    color: #28a745;\n    font-size: 24px;\n    margin-right: 12px;\n  }\n\n  .info-message {\n    color: #333;\n  }\n}\n\n.images-preview {\n  display: flex;\n  overflow-x: auto;\n  gap: 16px;\n  padding: 8px;\n  scroll-snap-type: x mandatory;\n}\n\n.image-preview-item {\n  flex: 0 0 calc(50% - 16px);\n  scroll-snap-align: start;\n  position: relative;\n}\n\n.image-diagnostis {\n  width: 100%;\n  height: 500px;\n  border-radius: 8px;\n}\n\n.delete-image {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  border-radius: 50%;\n  padding: 4px;\n  cursor: pointer;\n}\n\n.image-thumnail {\n  max-width: 60px;\n  min-width: 60px;\n  height: 60px;\n}\n\n.nuti-summary {\n  display: flex;\n  align-items: center;\n}\n\n.box-category {\n  border: solid 2px #00800042;\n}\n\n.box-info-image {\n  height: 100px;\n  max-height: 100px;\n  width: 100%;\n}\n\n@media (max-width: 426px) {\n  .image-preview-item {\n    flex: 0 0 calc(100% - 16px);\n    scroll-snap-align: start;\n    position: relative;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
